import apiClient from '../apiClient';
import { DELETE_CITY_GROUP_URL } from '../apiUrl';

const deleteCityGroupApi = Id => {
  return apiClient.delete(DELETE_CITY_GROUP_URL(Id));
};

export default deleteCityGroupApi;
